// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6008":"5014154e","9973":"c10eb5b9"}[chunkId] + ".chunk.css";
};